export default "__VITE_ASSET__ac8ecadb__"